<template>
  <main class="marketing-email-edit-recipient">

    <loading v-if="loading"
             class="marketing-email-edit-recipient-loading" />

    <app-form v-else
              ref="appForm"
              @submit="onSubmit">
      <marketing-form-senders v-if="item"
                              v-model="senders"
                              :channel-data="item"
                              :view="viewOnly"
                              channel-type="EMAIL"
                              @changed-external="hasExternalFileChanged = true"
                              @change-timeFilterActive = "isCustomSegmentedListTimeFilterActive = $event"
                              @input="setHasEdited" />

      <div class="marketing-email-edit-recipient-actions">
        <button v-if="!viewOnly"
                class="btn btn-outline btn-extra-round"
                type="button"
                @click="saveDrafts">
            {{$t('message.marketingGenerics.message.saveDraft')}}
        </button>

        <button class="btn btn-primary btn-extra-round"
                type="submit">
            {{$t('message.generics.message.advance')}}
        </button>
      </div>
    </app-form>
  </main>
</template>

<script>
import Loading from "@/components/generic/Loading.vue";
import AppForm from "@components/form/Form.vue";
import MarketingFormSenders from "@components/modules/marketing/generic/form/senders/MarketingFormSenders";
import EventBus from "@packages/event-bus/index";

export default {
  components: {
    AppForm,
    MarketingFormSenders,
    Loading,
  },

  props: {},

  computed: {
    isSegmentedList() {
      return this.senders.sendType === "SIMPLE_SEGMENTED_LIST";
    },
    isExternalList() {
      return this.senders.sendType === "EXTERNAL";
    },
    viewOnly() {
      return this.$store.state.marketing.email.edit.viewOnly;
    },
    isCustomSegmentedList() {
      return this.senders.sendType === "CUSTOM_SEGMENTED_LIST";
    },
  },

  watch: {},

  data() {
    return {
      senders: {
        sendType: undefined,
        configuration: undefined,
        sourceNote: undefined,
        file: undefined,
      },
      item: undefined,
      loading: false,
      hasEdited: false,
      hasExternalFileChanged: false,
      isCustomSegmentedListTimeFilterActive: false
    };
  },

  async created() {
    this.$store.commit("SET_EMAIL_EDIT_STEP", 2);

   await this.fetchEmail();
  },

  methods: {
    setHasEdited() {
      this.hasEdited = true;
    },
    validateRecipientType() {
      if (
        this.isExternalList &&
        !this.senders.file &&
        !Array.isArray(this.senders.configuration)
      ) {        
        throw this.$t('message.errorMessages.message.selectFile')        
      }

      else if (
        this.isSegmentedList &&
        (!this.senders.configuration ||
          Array.isArray(this.senders.configuration))
      ) {        
        throw this.$t('message.errorMessages.message.selectList')       
      }
      
      else if(this.isCustomSegmentedList && this.isCustomSegmentedListTimeFilterActive && !this.senders.configuration.timeFilterType) {        
        throw this.$t('message.errorMessages.message.selectEntryCriteria')        
      }

      else {        
        return true
      }
    },
    async saveDrafts() {
      try {
        const isValid = await this.validateRecipientType();
  
        if (isValid) {
          if(this.isExternalList && this.item.rawContent.includes("{PRIMEIRO_NOME}")) {
            return EventBus.$emit("show-message", {
                    type: "ERROR",
                    message: "Não é possível utilizar base externa com variáveis no corpo da mensagem",
                });   
          } 
          this.setRecipients();
        }        
      } catch (error) {
        return EventBus.$emit("show-message", {
          type: "ERROR",
          message: error,
        });
      }
    },
    async setRecipients() {
      if (this.viewOnly) {
        return;
      }

      if (!this.hasEdited) {
        return;
      }

      if(this.isExternalList && !this.hasExternalFileChanged) {
        this.$router.push({
          path: "/marketing/email",
        });
        EventBus.$emit("show-message", {
          type: "SUCCESS",
          message: this.$t('message.successMessages.message.draftSaved'),
        });
        return
      }

      try {
        this.checkValidationsForCustomSegmentedList();

        EventBus.$emit("SHOW_SPINNER");

        if(!this.senders.sendType) {
          this.$router.push({
          path: "/marketing/email",
          });
          EventBus.$emit("show-message", {
          type: "SUCCESS",
          message: this.$t('message.successMessages.message.draftSaved'),
          });
          return
        }

        const item = await this.$api.marketing.email.message.setSendType({
          emailId: this.item.id,
          type: this.senders.sendType,
          configurationSimplesSegmentedList: this.senders.configuration,
          sourceNote: this.senders.sourceNote,
          file: this.senders.file,
        });

        this.$router.push({
        path: "/marketing/email",
        });

        EventBus.$emit("show-message", {
          type: "SUCCESS",
          message: this.$t('message.successMessages.message.draftSaved'),
        });

        this.item = item;
      } catch (error) {
        if(this.isExternalList) this.senders.file = undefined
        throw error.response.data.message
        //empty
      } finally {
        EventBus.$emit("CANCEL_SPINNER");
      }
    },
    async onSubmit() {
      try {
        const isValid = await this.validateRecipientType();
        if (!this.viewOnly && isValid) {
          if(this.isExternalList && this.item.rawContent.includes("{PRIMEIRO_NOME}")) {
            return EventBus.$emit("show-message", {
                    type: "ERROR",
                    message: "Não é possível utilizar base externa com variáveis no corpo da mensagem",
                });   
          } 
          await this.setRecipients();
        }
  
        this.advanceStep();        
      } catch (error) {
        return EventBus.$emit("show-message", {
          type: "ERROR",
          message: error,
        });
      }
    },
    async advanceStep() {
      this.$store.commit("SET_EMAIL_EDIT_STEP", 3);

      this.$router.push({
        path: `/marketing/email/editar/${this.item.id}/verificacao`,
      });
    },
    async fetchEmail() {
      this.loading = true;

      const emailId = this.$route.params.emailId;

      const email = await this.$api.marketing.email.message.get({
        emailId,
      });

      this.item = email;

      this.$store.commit("EMAIL_EDIT_SET_AUTOMATION", email.isAutomationFlow);

      this.loading = false;
    },
    checkValidationsForCustomSegmentedList() {
      if (this.senders.configuration === undefined) {
        this.senders.configuration = {
          timeFilterType: undefined,
          gender:  null,
          startAge:  0,
          endAge: 100,
          timeFilter: {
              type:  "PERIOD",
              startPeriod:  new Date().toISOString().substring(0, 10),
              endPeriod:  new Date().toISOString().substring(0, 10),
              days:  undefined   
          }
        }
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.marketing-email-edit-recipient {
  .marketing-email-edit-recipient-loading {
    margin: 30px auto;
    width: 30px;
    height: 30px;
  }

  .marketing-email-edit-recipient-actions {
    display: flex;
    justify-content: center;
    gap: 20px;
    padding: 50px 0;
  }
}
</style>

